import * as React from 'react';

import BaseSaleHistoryLayout from "~/apps/pos/mobile/pages/BaseSaleHistoryLayout";
import SaleHelpDesktop from "~/apps/pos/mobile/containers/sales/SaleHelpDesktop";

export default function () {
  return (
    BaseSaleHistoryLayout(
      <SaleHelpDesktop />
    )
  );
};
